import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ScenariosGrid from '../../components/Budget/ScenariosGrid';
import LoadError from '../../components/Budget/LoadError';
import { useBudgetScenarios } from '../../hooks/api/budgetScenarios';
import { useTitleContext } from '../../store/Page/TitleContext';

// CALL-762: What-if scenarios overview. The list shows all scenarios across budget versions — the grid's
// own column filters handle scoping (no version selector here).
const BudgetScenarios = () => {
    const { t } = useTranslation('budget');
    const { onChange: changeTitle } = useTitleContext();
    const [scenarios, isLoading, { isError, error, refetch }] = useBudgetScenarios();

    // The AppBar otherwise falls back to the nav menu's own caption, which is untranslated English
    // ("Scenarios") — beside a page heading reading "Szenarien" (CALL-784). Every other budget page that
    // has a translated heading sets its title the same way.
    useEffect(() => {
        changeTitle(t('scenarios.title'));
        return () => {
            changeTitle(undefined);
        };
    }, [changeTitle, t]);

    if (isError) return <LoadError error={error} onRetry={refetch} />;

    return <ScenariosGrid scenarios={scenarios} isLoading={isLoading} />;
};

export default BudgetScenarios;
